export const GET_DEVICES_LIST_API = "/api/devices/list";
export const GET_DEVICE_API = "/api/devices/getDevice";
export const EDIT_DEVICE_API = "/api/devices/edit";
export const ADD_DEVICE_API = "/api/devices/add";